import { makeStyles } from 'tss-react/mui'
import { fundingColors as C } from '../../theme/figmaColors'

export const useStyles = makeStyles()(() => ({
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 8px',
    borderRadius: 8,
    border: `1px solid ${C.reviewBorder}`,
    background: C.cardBg,
    cursor: 'pointer',
  },
  icon: {
    width: 14,
    height: 14,
  },
  label: {
    fontSize: 11,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: C.darkText,
  },
}))
